/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import { Button, ButtonGroup, ModalActions, StyledModal, useFlags } from 'sarsaparilla';

export default function SummaryModal({
    children,
    isSummaryModalOpen,
    onSubmitHandler,
    reservations,
    toggleSummaryModal,
}) {
    const hasReservations = !!reservations.length;
    const { iaPassesGovShutdown } = useFlags();

    if (!hasReservations) {
        return null;
    }

    return (
        <StyledModal
            size="md"
            onRequestClose={toggleSummaryModal}
            shouldActionsStickInMobile
            isOpen={isSummaryModalOpen}
            heading="Summary"
        >
            <>
                {children}
                <ModalActions>
                    <ButtonGroup isFullWidthOnMobile={false} isStretchedToFit>
                        <Button appearance="link" onClick={toggleSummaryModal}>
                            Go Back
                        </Button>
                        <Button
                            onClick={onSubmitHandler}
                            isDisabled={iaPassesGovShutdown}
                        >
                            Proceed to Cart
                        </Button>
                    </ButtonGroup>
                </ModalActions>
            </>
        </StyledModal>
    );
}

SummaryModal.propTypes = {
    children: PropTypes.node,
    isSummaryModalOpen: PropTypes.bool.isRequired,
    onSubmitHandler: PropTypes.func.isRequired,
    reservations: PropTypes.array.isRequired,
    toggleSummaryModal: PropTypes.func.isRequired,
};
